import React from "react";
import { NavLink, Link } from "react-router-dom";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import "overlayscrollbars/css/OverlayScrollbars.css";
import thumb_1 from "../../assets/images/home/thumb-1.svg";
import thumb_2 from "../../assets/images/home/thumb-2.svg";
import thumb_3 from "../../assets/images/home/thumb-3.svg";
import thumb_4 from "../../assets/images/home/thumb-4.svg";
import Footer from "../footer/footer";
import logo from "../../assets/images/header/cmx-logo.svg";
import ios_ps from "../../assets/images/footer/ios_appStore.svg";
import android_ps from "../../assets/images/footer/andriod_playStore.svg";
import { Helmet } from "react-helmet";
import metatags from "../static/metatags";
class Home extends React.Component {
  render() {
    return (
      <>
        <section className="cmx-flex-homepage">
          <Helmet>
            <title>{metatags.commonMetatag.title}</title>
            <meta name="description" content={metatags.commonMetatag.description} />
          </Helmet>
          <section className="row">
            <section className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <aside className="logo text-center">
                <figure>
                  <a onClick={this.props.h_goHome} href="javascript:;" title="PASSPORT BY CMX">
                    <img src={logo} alt="PASSPORT BY CMX" className="img-fluid" />
                  </a>
                </figure>
              </aside>
              <aside className="head text-center pt-4 pb-4">
                <h1>
                  <span className="txt-btm d-block pt-1">Your Customizable Movie Membership Program</span>
                </h1>
              </aside>
              <section className="row grid-blk">
                <section className="sec col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                  <section className="box flex text-center">
                    <figure>
                      <img src={thumb_1} alt="100% Flexible" className="img-fluid" />
                    </figure>
                    <h2>
                      100% Flexible <span className="d-block pt-md-2 pt-1">Membership Your Way</span>
                    </h2>
                    <p>
                      <span>You choose your own customizable plan.</span>
                    </p>
                  </section>
                </section>
                <section className="sec col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                  <section className="box rollover text-center">
                    <figure>
                      <img src={thumb_2} alt="Rollover" className="img-fluid" />
                    </figure>
                    <h2>
                      Rollover <span className="d-block pt-md-2 pt-1">Unused Credits</span>
                    </h2>
                    <p>Unused credits will rollover for up to 12 months.</p>
                  </section>
                </section>
                <section className="sec col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                  <section className="box upcharge text-center">
                    <figure>
                      <img src={thumb_3} alt="No Additional Fees" className="img-fluid" />
                    </figure>
                    <h2>
                      No Additional Fees <span className="d-block pt-md-2 pt-1">No Online Convenience Fees</span>
                    </h2>
                    <p>
                      <span>
                        We’re waiving the convenience and blockbuster fees plus you’ll be able to watch 3D, PLF, and Dolby ATMOS at no additional cost.<sup>1</sup>
                      </span>
                    </p>
                  </section>
                </section>
                <section className="sec col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                  <section className="box discount text-center">
                    <figure>
                      <img src={thumb_4} alt="10% Discount on Food and Beverages" className="img-fluid" />
                    </figure>
                    <h2>
                      10% Discount on Food and Beverages <span className="d-block pt-md-2 pt-1">For You + Your Guests</span>
                    </h2>
                    <p>
                      <span>
                        Save 10% on all Food and Beverage Purchases for you and your guests.<sup>2</sup>
                      </span>
                    </p>
                  </section>
                </section>
              </section>

              <section className={`search-blk text-center pt-3 ${this.props.state.mobileBtmMenu_SH ? "show" : ""}`}>
                <section className="container mobile-bg">
                  {this.props.state.redirectfromapp && (
                    <section className="only-avbmob-blk">
                      <h2>CMX Passport is only available for use in our Mobile App.</h2>
                      <figure className="apps-logo">
                        <a href="https://apps.apple.com/us/app/cmx-cinemas/id1556073550" target="_blank" title="App Store">
                          <img src={ios_ps} width="100" alt="IOS App Store" className="img-fluid" />
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.influx.cinema.cmx" target="_blank" title="Google Play">
                          <img src={android_ps} width="100" alt="Android App Store" className="img-fluid" />
                        </a>
                      </figure>
                    </section>
                  )}
                  <h6 className="pt-sm-4 pt-2 pb-3">Join Today and Pick Your Favorite Theatre</h6>
                  <section className="search-wrap">
                    <aside className="form-group">
                      <input 
                        type="text" 
                        placeholder="Search by city, theatre or zipcode" 
                        value={this.props.state.searchInputValue} 
                        onChange={(e) => this.props.home_searchInputChange(e)} 
                        className={`${this.props.state.homeSettingsAPI.length > 0 && Object.keys(this.props.state.homeSettingsAPI[0].configs).length > 0 && !this.props.state.homeSettingsAPI[0].configs.subscriptionEnabled ? 'disabled':''}`}
                      />
                    </aside>
                    <OverlayScrollbarsComponent
                      options={{
                        paddingAbsolute: true,
                        autoUpdate: true,
                        scrollbars: {
                          clickScrolling: true,
                          visibility: "auto",
                        },
                        overflowBehavior: {
                          x: "hidden",
                          y: "scroll",
                        },
                      }}
                      className="mcsbWrapper"
                      id="categoryOverlayScrollbar"
                    >
                      <aside className={`search-list-blk ${this.props.state.home_searchData.length > 0 ? "hg" : ""}`}>
                        <ul className="text-start">
                          {this.props.state.home_searchData.map((data, index) => {
                            return (
                              <li key={index}>
                                <p onClick={(e) => this.props.home_locationClick(e, data)}>
                                  {data.name}{" "}
                                  <span>
                                    {data.address1}, {data.address2 != null ? data.address2 + "," : ""} {data.city}, {data.state} {data.zipcode}{" "}
                                  </span>
                                </p>
                              </li>
                            );
                          })}
                        </ul>
                      </aside>
                    </OverlayScrollbarsComponent>
                    {/* {
                      (this.props.state.home_searchData.length == 0) || (this.props.state.searchInputValue != '') &&
                      <section className="error-msg">
                        <p>No city, theater, mall</p>
                      </section>
                    } */}

                    {this.props.state.notifySH == false ? (
                      this.props.state.loc_planJson.length > 0 && (
                        <section className="search-details-blk">
                          <aside className="head">
                            <h3>{this.props.state.loc_name}</h3>
                            {/* <h3>{this.props.state.searchInputValue}</h3> */}
                            <p>
                              Plan starting at <strong>${this.props.state.planStartPrice}</strong> per month
                            </p>
                          </aside>
                          <aside className="body">
                            <ul>
                              {this.props.state.partyPriceArray.map((partyOfPrice, priceIndex) => {
                                return (
                                  <li key={priceIndex}>
                                    <p>
                                      <strong>Party of {priceIndex + 2}:</strong> Starting at <strong>${partyOfPrice}</strong> per month
                                    </p>
                                  </li>
                                );
                              })}
                            </ul>
                            <aside className="cmx-flex-btn-group text-center">
                              <a onClick={this.props.customPlan} className="flex-btn" href="javascript:;" title="Build Your Plan">
                                <span>Build Your Plan</span>
                              </a>
                            </aside>
                          </aside>
                        </section>
                      )
                    ) : (
                      <section className="notify-blk">
                        <aside className="alert-wrap">
                          <h2>Sorry, CMX Passport is currently not available at this location.</h2>
                        </aside>
                        <section className="notify-wrap">
                          <p>
                            <span>Notify me when CMX Passport is available.</span>
                          </p>
                          <aside className="form-group">
                            <aside className="form-inner">
                              <input
                                type="text"
                                placeholder="Enter your Email ID"
                                autoComplete="off"
                                name="notifyEmailValue"
                                onChange={(e) => this.props.Home_NotifyMailOnChange(e)}
                                onBlur={this.props.Home_NotifyOnblur}
                                value={this.props.state.notifyEmailValue}
                              />
                            </aside>
                            <p className="error-msg">{this.props.state.notifyemailErrorMsg}</p>
                          </aside>
                          <aside className="cmx-flex-btn-group text-center">
                            <a onClick={this.props.notifySubmitBtn} className={`flex-btn ${this.props.notifyBtnDisabled() ? "disabled" : ""}`} href="javascript:;" title="SUBMIT">
                              <span>SUBMIT</span>
                            </a>
                          </aside>
                        </section>
                      </section>
                    )}
                  </section>
                  <aside className="disableMsg">
                    {
                      this.props.state.homeSettingsAPI.length > 0 && Object.keys(this.props.state.homeSettingsAPI[0].configs).length > 0 && !this.props.state.homeSettingsAPI[0].configs.subscriptionEnabled ?
                      <p>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>
                        {this.props.state.homeSettingsAPI[0].configs.description}</p>
                      :null
                    }
                  </aside>
                  <section className="sup-blk">
                    <p>
                      <sup>1</sup>Excludes IMAX and DBOX formats. No fees apply to Passport Credits only. Other fees apply to full-priced tickets.
                    </p>
                    <p>
                      <sup>2</sup>Excludes alcoholic beverages
                    </p>
                  </section>
                </section>
                <aside className="mob-close-btn">
                  <a onClick={this.props.home_btmCloseBtn} className="d-block" href="javascript:;" title="Close">
                    &nbsp;
                  </a>
                </aside>
              </section>
            </section>
          </section>

          <section className="btm-strap-mobile text-center">
            <p>
              <a onClick={this.props.home_mobileClick} className="text-decoration-underline" href="javascript:;" title="Select Primary Theatre">
                Select Primary Theatre
              </a>
            </p>
          </section>

          {this.props.state.mobileBtmMenu_SH && <section className="mob-shadow">&nbsp;</section>}
        </section>

        {/* footer > start */}
        {/* {this.props.state.footerC_SH && <Footer state={this.state}/>} */}
        {/* footer > end */}
      </>
    );
  }
}

export default Home;
